module.exports = __webpack_public_path__ + "img/Configuration1.85330884.jpg";